import axios from 'axios';

// Create an instance of axios
const axiosInstance = axios.create({
    baseURL: 'https://api.horeca-masters.nl', // replace with your API base URL
    // baseURL: 'http://localhost:4000', // for local development
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add a request interceptor to include the Bearer token and tenant ID
axiosInstance.interceptors.request.use((config) => {
    // Haal de auth token uit sessionStorage
    const token = sessionStorage.getItem('authToken');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    // Haal het subdomein uit de huidige URL
    const hostname = window.location.hostname; // Bijv. "panache.horeca-masters.nl"
    const subdomain = hostname.split('.')[0]; // Bijv. "panache"

    // Voeg de X-Tenant-ID header toe met het subdomein
    if (subdomain && subdomain !== 'api') { // Zorg dat "api" niet als tenant wordt gebruikt
        config.headers['X-Tenant-ID'] = subdomain;
    } else {
        console.warn('Geen geldig subdomein gevonden, geen X-Tenant-ID toegevoegd');
    }

    return config;
}, (error) => {
    return Promise.reject(error);
});

export default axiosInstance;
